import { createAction } from 'redux-actions';

export const changeSidebarVisibility = createAction('CHANGE_SIDEBAR_VISIBILITY');
export const changeMobileSidebarVisibility = createAction('CHANGE_MOBILE_SIDEBAR_VISIBILITY');
